import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
export default function Comp() {
    const { t } = useLang('theProduct.SectionA6');

    return (
        <>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <img src="https://websiteoss.ecoflow.com/upload/image/1741259003573/Frame%201612690156.jpg" className="demo-img-full" />
        </>
    );
}
